import { IMotivoCompra } from "../../../Interfaces/Geral/GestaoDeCadastro/MotivoCompra/MotivoCompraInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarMotivoCompraService() {
    return Service(
        Axios.get<Array<IMotivoCompra>>(
            `/vendas/motivocompra/listarmotivocompra`
        )
    );
}

export async function InserirMotivoCompraService(requestBody: IMotivoCompra) {
    return Service(
        Axios.post(`/vendas/motivocompra/inserirmotivocompra`, requestBody)
    );
}

export async function DeletarMotivoCompraService(ID_MOTIVO_COMPRA: number) {
    return Service(
        Axios.delete(
            `/vendas/motivocompra/deletamotivocompra?ID_MOTIVO_COMPRA=${ID_MOTIVO_COMPRA}`
        )
    );
}
